import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";
import { Link } from "react-router-dom";

const OrderApprovals = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);

  const getPendingOrders = async () => {
    try {
      setLoading(true);
      const res = await Axios.get("/api/order/pending");
      console.log(res, "res");
      setOrders(res.data.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const approveOrder = async (id) => {
    if (!window.confirm("Approve this order?")) return;

    try {
      setActionLoading(id);

      await Axios.put(`/api/order/approve/${id}`);

      // ✅ REMOVE FROM UI INSTANTLY (no API call)
      setOrders((prev) => prev.filter((o) => o._id !== id));
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Error approving order");
    } finally {
      setActionLoading(null);
    }
  };

  const rejectOrder = async (id) => {
    if (!window.confirm("Reject this order?")) return;

    try {
      setActionLoading(id);

      await Axios.put(`/api/order/reject/${id}`);

      // ✅ REMOVE FROM UI INSTANTLY
      setOrders((prev) => prev.filter((o) => o._id !== id));
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Error rejecting order");
    } finally {
      setActionLoading(null);
    }
  };

  useEffect(() => {
    getPendingOrders();
  }, []);

  return (
    <div className="container-fluid">
      <h3 className="mb-4">Order Approvals</h3>

      {/* Loading */}
      {loading && <p>Loading...</p>}

      {/* Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {orders.length > 0 ? (
                  orders.map((order, index) => (
                    <tr key={order._id}>
                      <td>{index + 1}</td>
                      <td>
                        <Link to={`/order/${order._id}`}>
                          ADC_{order?.orderId}
                        </Link>
                      </td>
                      <td>{order.user?.name}</td>
                      <td>{order.user?.phone}</td>

                      {/* Dates */}
                      <td>
                        {order.orderItems?.[0]?.startDate
                          ? new Date(
                              order.orderItems[0].startDate,
                            ).toLocaleDateString("en-GB")
                          : "-"}
                      </td>

                      <td>
                        {order.orderItems?.[0]?.endDate
                          ? new Date(
                              order.orderItems[0].endDate,
                            ).toLocaleDateString("en-GB")
                          : "-"}
                      </td>

                      <td>₹ {order.orderAmount}</td>

                      {/* Actions */}
                      <td>
                        <button
                          className="btn btn-success btn-sm mr-2"
                          disabled={actionLoading === order._id}
                          onClick={() => approveOrder(order._id)}
                        >
                          {actionLoading === order._id
                            ? "Processing..."
                            : "Approve"}
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          disabled={actionLoading === order._id}
                          onClick={() => rejectOrder(order._id)}
                        >
                          {actionLoading === order._id
                            ? "Processing..."
                            : "Reject"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No pending orders
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderApprovals;
